class ComponentMarquee extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      track: ".marquee-track",
      group: ".marquee-group"
    });
  }

  connectedCallback() {
    super.connectedCallback();

    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this);
    this.observer.observe(this.elements.group);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer.disconnect();
  }

  update() {
    const track = this.elements.track;
    const group = this.elements.group;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = group.getBoundingClientRect().width + gap;

    if (!group.children.length || !distance) {
      return;
    }

    const copies = Math.ceil(this.clientWidth / distance) + 1;

    while (track.children.length > copies) {
      track.lastElementChild.remove();
    }

    while (track.children.length < copies) {
      const clone = group.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
    }

    track.style.setProperty("--marquee-distance", `${distance}px`);
  }
}

customElements.define("component-marquee", ComponentMarquee);
